/*
  HODL Vault – eigene Bausteine statt Elfsight (gehört zu vault-native.css)
  1. Videos: das YouTube-Video lädt erst nach dem Klick (youtube-nocookie.com).
  2. FAQ-Seite: Suche über Fragen und Antworten, Suchvorschläge, aktives Thema in der Liste.
  3. Kontakt-Knopf: öffnet die Wege; Esc oder Klick daneben schliesst.
  4. LinkedIn: Pfeile blättern durch die Kartenreihe (ohne Skript scrollt sie seitlich).
*/
(() => {
  const d = document;

  // 1. Videos
  d.addEventListener('click', (e) => {
    const a = e.target.closest('[data-vvid]');
    if (!a || a.dataset.vvidOn) return;
    e.preventDefault();
    a.dataset.vvidOn = '1';
    const f = d.createElement('iframe');
    f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(a.dataset.vvid)}?autoplay=1&rel=0&modestbranding=1`;
    f.title = a.dataset.vvidTitle || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    a.appendChild(f);
    a.removeAttribute('href');
  });

  // 2. FAQ-Suche
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const initFaq = (scope) => {
    scope.querySelectorAll('.vfh').forEach((root) => {
      if (root.dataset.vfhInit) return;
      root.dataset.vfhInit = '1';
      const box = root.querySelector('[data-vfh-search]');
      const input = root.querySelector('[data-vfh-input]');
      const hits = root.querySelector('[data-vfh-hits]');
      const empty = root.querySelector('[data-vfh-empty]');
      const items = Array.from(root.querySelectorAll('[data-vfh-item]'));
      const groups = Array.from(root.querySelectorAll('[data-vfh-group]'));
      if (!box || !input || !items.length) return;
      const total = items.length;
      const text = new Map(items.map((it) => [it, norm(`${it.textContent} ${it.dataset.vfhTags || ''}`)]));
      const chips = Array.from(root.querySelectorAll('[data-vfh-term]'));
      const run = () => {
        const q = norm(input.value.trim());
        const words = q.split(/\s+/).filter(Boolean);
        let shown = 0;
        items.forEach((it) => {
          const hit = !words.length || words.every((w) => text.get(it).includes(w));
          it.hidden = !hit;
          if (hit) shown += 1;
          if (words.length && hit && shown <= 3) it.open = true;
          if (!words.length) it.open = false;
        });
        groups.forEach((g) => { g.hidden = !g.querySelector('[data-vfh-item]:not([hidden])'); });
        if (hits) hits.textContent = words.length ? `${shown} von ${total}` : `${total} Fragen`;
        if (empty) empty.hidden = shown > 0;
        chips.forEach((c) => c.setAttribute('aria-pressed', q && norm(c.dataset.vfhTerm) === q ? 'true' : 'false'));
      };
      let t;
      input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 120); });
      input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { input.value = ''; run(); } });

      // Suchvorschläge: ein Klick sucht, ein zweiter hebt die Suche wieder auf
      chips.forEach((c) => c.addEventListener('click', () => {
        const on = c.getAttribute('aria-pressed') === 'true';
        input.value = on ? '' : c.dataset.vfhTerm;
        run();
        if (on) return;
        const first = root.querySelector('[data-vfh-item]:not([hidden])');
        if (first && first.getBoundingClientRect().top > window.innerHeight * 0.75) {
          const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          first.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
        }
      }));

      // Aktives Thema markieren
      const cats = new Map(Array.from(root.querySelectorAll('[data-vfh-cat]')).map((a) => [a.dataset.vfhCat, a]));
      if ('IntersectionObserver' in window && cats.size) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            const id = en.target.id.replace(/^faq-/, '');
            cats.forEach((a, k) => a.classList.toggle('is-on', k === id));
          });
        }, { rootMargin: '-30% 0px -60% 0px' });
        groups.forEach((g) => io.observe(g));
      }
    });
  };

  // 3. Kontakt-Knopf
  const initChat = () => {
    const root = d.querySelector('[data-vchat]');
    if (!root || root.dataset.vchatInit) return;
    root.dataset.vchatInit = '1';
    const btn = root.querySelector('[data-vchat-toggle]');
    const panel = root.querySelector('[data-vchat-panel]');
    if (!btn || !panel) return;
    const set = (open) => {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    btn.addEventListener('click', (e) => { e.preventDefault(); set(panel.hidden); });
    d.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
    d.addEventListener('click', (e) => { if (!panel.hidden && !root.contains(e.target)) set(false); });
  };

  // 4. LinkedIn-Reihe
  const initRail = (scope) => {
    scope.querySelectorAll('[data-vli]').forEach((rail) => {
      if (rail.dataset.vliInit) return;
      rail.dataset.vliInit = '1';
      const track = rail.querySelector('[data-vli-track]');
      const nav = rail.querySelector('[data-vli-nav]');
      const prev = rail.querySelector('[data-vli-prev]');
      const next = rail.querySelector('[data-vli-next]');
      if (!track || !nav || !prev || !next) return;
      const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = () => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        nav.hidden = max <= 0;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: still ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: still ? 'auto' : 'smooth' }));
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  const init = (scope = d) => { initFaq(scope); initChat(); initRail(scope); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => init());
  else init();
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
